import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LocalStorageKeys } from '../LocalStorageKeys';
import { ConfigService } from '../services/config/config.service';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { getXClientId } from '../utils/deviceUtils';
import { includeAuthHeader } from '../utils/tokenUtils';

@Injectable()
export class UmsInterceptor implements HttpInterceptor {
  constructor(private configService: ConfigService, private localStorage: LocalStorageService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (includeAuthHeader(request, this.configService.applicationConfig)) {
      const updatedHeaders = this.getHeaders(request.headers, !request.url.includes(this.configService.applicationConfig.geoLocationURL));
      const updatedRequest = request.clone({ headers: updatedHeaders });

      return next.handle(updatedRequest).pipe(
        tap((event) => {
          if (event instanceof HttpResponse && event.status === 200 && event.body?.header?.code === -1) {
            const errors = event.body.header.errors;
            if (errors?.length > 0) {
              throw errors[0];
            }
          }
        })
      );
    }
    return next.handle(request);
  }

  private getHeaders(reqHeaders: HttpHeaders, includeXSessionAuth = true): HttpHeaders {
    let headers = reqHeaders;
    headers = headers.set('x-client-id', getXClientId());
    const authData = this.localStorage.getItem(LocalStorageKeys.AUTHDATA);
    if (authData) {
      headers = headers.set('Authorization', `Bearer ${authData}`);
    }
    if (includeXSessionAuth) {
      const accessToken = this.localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN);
      if (accessToken) {
        headers = headers.set('x-session-authorization', accessToken);
      }
    }
    return headers;
  }
}
